import { TileCoordinates } from "../../../lib/runescape/coordinates";
import { MovementAbilities } from "../../../lib/runescape/movement";
import InteractionTopControl from "../../ui/map/InteractionTopControl";
import { ValueInteraction } from "../../../lib/gamemap/interaction/ValueInteraction";
import { Observable, observe } from "../../../lib/reactive";
import { PathStepEntity } from "../../ui/map/entities/PathStepEntity";
import { PathGraphics } from "../../ui/path_graphics";
import { AbilityLens } from "../AbilityLens";
var observe_combined = Observable.observe_combined;
var arrow = PathGraphics.arrow;
var isFarDive = MovementAbilities.isFarDive;
import { HostedMapCollisionData } from "../../../lib/runescape/CollisionData";
export class DrawAbilityInteraction extends ValueInteraction {
    constructor(ability, assumptions) {
        super({});
        this.ability = ability;
        this.assumptions = assumptions;
        this._possibility_overlay = null;
        this._preview_arrow = null;
        this.start_position = observe(null).equality(TileCoordinates.eq2);
        this.current_target = observe(null).equality((a, b) => TileCoordinates.eq2(a?.tile, b?.tile) && a?.forced == b?.forced);
        this.overlay_tile = observe(null).equality(TileCoordinates.eq2);
        this.attachTopControl(new InteractionTopControl().setName(`Drawing ${ability}`));
        observe_combined({ start: this.start_position, target: this.current_target }).subscribe(({ start, target }) => {
            this.overlay_tile.set(start || target?.tile);
            this.updateArrow(start, target?.tile, target?.forced);
        });
        this.overlay_tile.subscribe(tile => this.updateDiveOverlay(tile));
        this.start_position.subscribe(() => this.updateInstructions(), true);
    }
    updateInstructions() {
        if (this.start_position.value()) {
            this.top_control.setContent(c("<div style='font-family: monospace; white-space:pre'></div>")
                .append(c().text(`[Click] valid target tile to confirm.`))
                .append(c().text(`[Shift + Click] to force any target tile.`))
                .append(c().text(`[Backspace] to reset start tile.`)));
        }
        else {
            this.top_control.setContent(c("<div style='font-family: monospace; white-space:pre'></div>")
                .append(c().text(`[Click] the origin tile of the ability.`)));
        }
    }
    setStartPosition(pos) {
        this.start_position.set(pos);
        return this;
    }
    async updateDiveOverlay(tile) {
        if (this.ability != "barge" && this.ability != "dive")
            return;
        if (this._possibility_overlay) {
            this._possibility_overlay.remove();
            this._possibility_overlay = null;
        }
        if (tile == null)
            return;
        this._possibility_overlay = new AbilityLens(tile, this.assumptions);
        this._possibility_overlay.addTo(this);
    }
    async updateArrow(start, hover, forced) {
        // Calculate the preview that needs to be drawn.
        let res = await (async () => {
            if (!start || !hover)
                return null;
            if (forced)
                return { from: start, to: hover, okay: true };
            else {
                let res = await MovementAbilities.generic(HostedMapCollisionData.get(), this.ability, this.assumptions, start, hover);
                return { from: start, to: res?.tile || hover, okay: !!res };
            }
        })();
        // Remove existing preview
        if (this._preview_arrow) {
            this._preview_arrow.remove();
            this._preview_arrow = null;
        }
        if (res) {
            let { from, to, okay } = res;
            // Draw the necessary preview
            this._preview_arrow = (okay ? new PathStepEntity({
                type: "ability",
                ability: this.ability,
                is_far_dive: this.ability == "dive" && await isFarDive(from, to),
                from: from,
                to: to
            }).setInteractive(false)
                : arrow(from, to).setStyle({
                    weight: 3,
                    color: "red"
                })).addTo(this);
        }
    }
    eventClick(event) {
        event.onPost(async () => {
            event.stopAllPropagation();
            let tile = event.tile();
            if (!this.start_position.value()) {
                this.start_position.set(tile);
            }
            else {
                if (event.original.shiftKey) {
                    const is_far_dive = this.ability == "dive" && await isFarDive(this.start_position.value(), tile);
                    this.commit({
                        type: "ability",
                        ability: this.ability,
                        is_far_dive: is_far_dive ? true : undefined,
                        from: this.start_position.value(),
                        to: tile
                    });
                }
                else {
                    const res = await MovementAbilities.generic(HostedMapCollisionData.get(), this.ability, this.assumptions, this.start_position.value(), tile);
                    if (res) {
                        const is_far_dive = this.ability == "dive" && await isFarDive(this.start_position.value(), res.tile);
                        this.commit({
                            type: "ability",
                            ability: this.ability,
                            is_far_dive: is_far_dive ? true : undefined,
                            from: this.start_position.value(),
                            to: res.tile
                        });
                    }
                }
            }
        });
    }
    eventHover(event) {
        event.onPre(() => {
            this.current_target.set({ tile: event.tile(), forced: event.original.shiftKey });
        });
    }
    eventKeyDown(event) {
        event.onPre(() => {
            if (this.start_position.value() != null && event.original.key == "Backspace") {
                event.stopAllPropagation();
                this.start_position.set(null);
            }
        });
        event.onPost(() => {
            if (event.original.key == "Shift")
                this.current_target.update(c => {
                    if (c)
                        c.forced = true;
                });
        });
    }
    eventKeyUp(event) {
        event.onPost(() => {
            if (event.original.key == "Shift")
                this.current_target.update(c => {
                    if (c)
                        c.forced = false;
                });
        });
    }
}
